import styled from "styled-components";
import { COLORS } from "../../../../constants/Styles";

export const ShipmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

export const ShipmentsRow = styled.div`
  display: flex;
  gap: 0.5rem 2rem;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const ShipmentsRowContainer = styled.div`
  display: flex;
  gap: 0.5rem 2rem;
  align-items: flex-end;
  flex-wrap: wrap;
  background-color: ${COLORS.inputGray};
  border-radius: 1rem;
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
`;

export const ShipmentsColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ShipmentActionContainer = styled.div`
  width: 4rem;
  padding-bottom: 0.5rem;
`;

export const PickUpInfo = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;
  color: ${COLORS.altSecondary};
`;

export const ShipmentDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 8rem;
`;
